import { Link, useLocation } from "react-router-dom";
import { FiClock, FiHome, FiLayers, FiUsers, FiBarChart2, FiRefreshCcw } from "react-icons/fi";
import { useTranslation } from "../hooks/useTranslation";
import { useWallet } from "../hooks/useWallet";
import NavHome from "../images/bottom-nav-home.png";
import NavCommunity from "../images/bottom-nav-community.png";
import NavStaking from "../images/bottom-nav-staking.png";
import NavSwap from "../images/bottom-nav-swap.png";

export default function BottomNavigator() {
    const { t } = useTranslation();
    const location = useLocation();
    const { freeStaking } = useWallet();

    const navItems = [
        { path: '/dashboard', icon: NavHome, label: t('dashboard.title') },
        { path: '/community', icon: NavCommunity, label: t('community.title') },
        { path: '/staking', icon: NavStaking, label: t('staking.title') },
        { path: '/swap', icon: NavSwap, label: t('swap.title') },
        // { path: '/deposit', icon: NavStaking, label: t('header.deposit') },
        { path: '/deposit-vt', icon: NavStaking, label: t('header.deposit') },
        { path: '/history', icon: FiClock, label: t('general.history') },
        { path: '/income-report', icon: FiBarChart2, label: t('incomeReport.title') },
    ];

    if (freeStaking) {
        navItems.push({ path: '/free-staking', icon: NavStaking, label: t('freeStaking.title') });
    }

    return (
        <div className="fixed bottom-4 left-0 w-full z-50 md:hidden">
            <div className="mx-auto max-w-4xl px-3 pb-[env(safe-area-inset-bottom)]">
                <div className="h-16 rounded-2xl border border-[#9770DD]/25 bg-[#110c18]/85 backdrop-blur-md shadow-lg shadow-[#000]/35">
                    <div className="flex items-center justify-around h-full">
                        {navItems.map((item) => {
                            const isActive = location.pathname.startsWith(item.path);
                            const Icon = item.icon;
                            return (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    className="flex flex-col items-center justify-center w-full h-full px-1"
                                >
                                    <div
                                        className={[
                                            "flex flex-col items-center justify-center gap-1 w-full max-w-[92px] py-2 rounded-xl transition-all duration-200",
                                            isActive
                                                ? "bg-[#9770DD]/20 text-[#DFD2FE] border border-[#9770DD]/35"
                                                : "text-[#ad90cb] hover:text-[#DFD2FE]",
                                        ].join(" ")}
                                    >
                                        {typeof Icon === 'string' ? (
                                            <img
                                                src={Icon}
                                                alt={item.label}
                                                className="size-6 object-contain"
                                            />
                                        ) : (
                                            <Icon
                                                className={[
                                                    "size-5",
                                                    isActive ? "text-[#9770DD]" : "text-[#ad90cb]",
                                                ].join(" ")}
                                            />
                                        )}
                                        <span className="text-[10px] font-semibold leading-none truncate max-w-full">
                                            {item.label}
                                        </span>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}